var React = require('react');

function TruckRamp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M544 320a96 96 0 1 0 96 96 96 96 0 0 0-96-96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 0a32 32 0 0 0-32 32v323.6L5.9 450a8 8 0 0 0-5.6 9.8l12.6 46.3a8 8 0 0 0 9.8 5.6l393.7-107.4c0 .33 0 .66.05 1C421.91 339.7 477 288 544 288a127.71 127.71 0 0 1 96 43.44V0z","className":"fa-primary","key":2})]);
}

TruckRamp.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = TruckRamp;

TruckRamp.default = TruckRamp;
